import { useCallback, useEffect, useState } from 'react';

export const useIsOverflow = (ref: HTMLElement | null) => {
	const getIsOverflow = useCallback(() => {
		if (!ref) {
			return false;
		}

		return ref.scrollHeight > ref.clientHeight;
	}, [ref]);

	const [isOverflow, setIsOverflow] = useState<boolean>(getIsOverflow());

	useEffect(() => {
		setIsOverflow(getIsOverflow());
	}, [getIsOverflow, ref]);

	return isOverflow;
};
